import React from 'react';
import Card from '../shared/Card';
import Button from '../shared/Button';
import { Check } from 'lucide-react';

const Tickets = () => {
  const ticketTypes = [
    {
      name: 'Early Bird tickets',
      price: 25,
      description: 'Discount applied at checkout. Available until 28th of February.',
      features: [
        'Access to Saturday night showcase',
        'Early bird discount',
        'Limited availability'
      ],
      featured: false,
      status: 'soldOut'
    },
    {
      name: 'Full price tickets',
      price: 30,
      description: 'Available from 1st March and until event is sold out.',
      features: [
        'Access to Saturday night showcase',
        'Regular admission'
      ],
      featured: true,
      status: 'soldOut'
    }
  ];

  return (
    <section id="tickets" className="bg-gray-50 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Make sure your friends and family will gain access to the Adelaide Samba Encontro showcase on the Saturday night. Limited places available. 
        </p>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
         <b>These tickets will grant you access to the Saturday showcase only, for Workshop registration use the links in the workshops section above.</b>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {ticketTypes.map((ticket, index) => (
            <Card 
              key={index} 
              className={`flex flex-col ${
                ticket.featured ? 'border-2 border-[#FFE135] relative' : ''
              }`}
            >
              {ticket.featured && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#FFE135] text-[#2E0854] px-4 py-1 rounded-full text-sm font-bold">
                  Full price
                </div>
              )}
              
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-[#2E0854] mb-2">{ticket.name}</h3>
                <div className="mb-4">
                  <span className="text-4xl font-bold">${ticket.price}</span>
                  <span className="text-gray-600"> AUD</span>
                </div>
                <p className="text-gray-600 mb-6">{ticket.description}</p>
                <ul className="space-y-3 mb-6">
                  {ticket.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-600">
                      <Check className="w-5 h-5 mr-2 text-[#FF4500]" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              <Button 
                variant={ticket.featured ? 'primary' : 'secondary'}
                className="w-full"
                href={ticket.href}
                status={ticket.status}
              >
                Purchase Tickets
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tickets;